import {  MemberTypeEnum } from "../../enums/member-type.enum";
import { Member } from "../../../shared/interface/member.interface";
import { StoreConfig } from "../../../shared/interface/StoreConfig.interface";
import { State } from "../../../shared/interface/state.interface";
import { Country } from "../../../shared/interface/country.interface";


export class BaseSettings {
    userInfo: Member;
    isoCountryCode: string;
    languageCode: string;
    memberType =  MemberTypeEnum;
    store: StoreConfig;
    states: State[];
    countries: Country[];
    registerMemberType:  MemberTypeEnum;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/models/payments/base-settings.model.ts